import { useQuery } from "@tanstack/react-query";
import { searchRemoteLdapUsers } from "@/services/ldapUsersApi";

export interface DirectoryUser {
  id: string;
  username: string;
  email: string | null;
  first_name: string | null;
  last_name: string | null;
  department: string | null;
  title: string | null;
  is_active: boolean;
  external_id: string;
  identity_provider_id: string | null;
}

export const useDirectoryUserSearch = (providerId: string | null, searchQuery: string) => {
  return useQuery({
    queryKey: ['directory_user_search', providerId, searchQuery],
    queryFn: async (): Promise<DirectoryUser[]> => {
      if (!providerId || !searchQuery || searchQuery.length < 2) return [];
      try {
        const results = await searchRemoteLdapUsers(providerId, searchQuery);
        return (results || []).map((u: any) => ({
          id: u.id || u.dn || '',
          username: u.username || u.cn || '',
          email: u.email || u.mail || null,
          first_name: u.firstName || u.givenName || null,
          last_name: u.lastName || u.sn || null,
          department: u.department || null,
          title: u.title || null,
          is_active: true,
          external_id: u.dn || '',
          identity_provider_id: providerId,
        }));
      } catch {
        return [];
      }
    },
    enabled: !!providerId && !!searchQuery && searchQuery.length >= 2
  });
};
